export default {
  validation: {
    nameRequired: "Nome é obrigatório",
    emailInvalid: "Email inválido",
    roleRequired: "Selecione uma função",
  },
  title: "Gestão de Usuários",
  description: "Gerencie os usuários da sua organização.",
  inviteTitle: "Convidar Usuário",
  inviteDescription: "Convide usuários para acessar os agentes de IA dos seus workspaces.",
  organizationUsersTitle: "Usuários da Organização",
  activeUsersTab: "Usuários Ativos",
  pendingInvitesTitle: "Convites Pendentes",
  pendingInvitesTab: "Convites Pendentes",
  noOrganizationUsers: "Nenhum usuário encontrado na organização",
  noInvites: "Nenhum convite pendente",
  fields: {
    name: "Nome",
    email: "Email",
    role: "Função",
    status: "Status",
    workspaces: "Workspaces"
  },
  roles: {
    admin: "Administrador",
    user: "Usuário",
    superadmin: "Super Admin"
  },
  selectRole: "Selecione uma função",
  selectWorkspaces: "Selecione workspaces",
  sendInvite: "Enviar Convite",
  noName: "Sem Nome",
  inviteSuccess: "Convite enviado com sucesso",
  inviteSuccessDescription: "O usuário receberá um email com instruções.",
  inviteError: "Falha ao enviar convite",
  inviteErrorDescription: "Ocorreu um erro ao enviar o convite.",
  duplicateInviteError: "Este usuário já foi convidado.",
  usersTable: {
    deleteConfirmTitle: "Excluir Usuário",
    deleteConfirmDescription: "Tem certeza de que deseja remover {{email}} da organização?",
    deletePendingConfirmDescription: "Tem certeza de que deseja cancelar este convite?",
    inviteDeleteSuccess: "Usuário removido com sucesso",
    inviteDeleteSuccessDescription: "O usuário foi removido da sua organização.",
    inviteDeleteError: "Falha ao remover usuário",
    inviteDeleteErrorDescription: "Ocorreu um erro ao remover o usuário."
  },
  deleteConfirmTitle: "Excluir Usuário",
  deleteConfirmDescription: "Tem certeza de que deseja remover {{email}} da organização?",
  deletePendingConfirmDescription: "Tem certeza de que deseja cancelar este convite?",
  deleteSuccess: "Usuário removido com sucesso",
  deleteSuccessDescription: "O usuário foi removido da sua organização.",
  deleteError: "Falha ao remover usuário",
  deleteErrorDescription: "Ocorreu um erro ao remover o usuário.",
  noWorkspaces: "Nenhum workspace vinculado",
  otherWorkspaces: "Outros workspaces",
  workspacesList: "Lista de workspaces",
  tabsWorkspaces: "Workspaces",
  tabsRole: "Função",
  editUserWorkspaces: "Editar workspaces do usuário",
  editUserWorkspacesDescription: "Selecione os workspaces que {name} terá acesso",
  editUserWorkspacesHelp: "Marque os workspaces que você deseja vincular a este usuário.",
  editUserRoleTitle: "Definir função do usuário",
  editUserRoleDescription: "Selecione a função que este usuário terá na organização.",
  roleAdmin: "Administrador",
  roleUser: "Usuário",
  roleSuperAdmin: "Super Admin",
  roleSuperAdminDesc: "Acesso total a todas as organizações e workspaces",
  editUserWorkspacesButton: "Editar workspaces vinculados",
  editUserSettings: "Editar configurações do usuário",
  noWorkspacesInOrganization: "Não há workspaces na organização",
  updateWorkspacesSuccess: "Salvo com sucesso!",
  updateWorkspacesSuccessDescription: "As configurações do usuário foram salvas.",
  updateWorkspacesError: "Erro ao atualizar workspaces",
  updateWorkspacesErrorDescription: "Ocorreu um erro ao atualizar os workspaces do usuário.",
  deleteUserTitle: "Excluir usuário",
  deleteUserDescription: "Tem certeza de que deseja excluir {name}? Esta ação não pode ser desfeita.",
  deleteUserButton: "Excluir usuário",
  deleteUserSuccess: "Usuário desativado",
  deleteUserSuccessDescription: "O usuário foi desativado com sucesso do sistema.",
  deleteUserError: "Erro ao desativar usuário",
  deleteUserErrorDescription: "Ocorreu um erro ao tentar desativar o usuário. Tente novamente mais tarde.",
  cannotDeleteSelf: "Você não pode excluir seu próprio usuário",
  deactivateSuccess: "Usuário desativado com sucesso",
  deactivateSuccessDescription: "O usuário foi desativado do sistema",
  deactivateError: "Erro ao desativar usuário",
  deactivateErrorDescription: "Ocorreu um erro ao desativar o usuário",
  loadingUserData: "Carregando dados do usuário..."
} as const;
